import AddStatus from "../../Components/Modals/AddStatus";
import Table from "../../Components/Table";
import { deleteStatusById, getStatus } from "../../Services/MasterService";

const Status = () => {
  const columns = [
    {
      label: "Name",
      value: "name"
    },
    {
      label: "Alias",
      value: "alias"
    },
  ];

  const renderAddModal = (openAddModal, setOpenAddModal) => {
    return (
      <AddStatus data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
    )
  };

  return (
    <Table
      api={getStatus}
      columns={columns}
      title={"Status Master"}
      addModal={renderAddModal}
      showAddButton={true}
      showExportButton={true}
      deleteApi={deleteStatusById}
    />
  );
}

export default Status;